// extracted by mini-css-extract-plugin
module.exports = {"card":"basicCard_card__1Droq","enrollment":"basicCard_enrollment__tIbnz","title":"basicCard_title__PLhxO","cardContent":"basicCard_cardContent__3uDME"};